///<reference path="../common/smart-mover.models.ts"/>
///<reference path="report-DP005-products-categories.ts"/>
///<reference path="../collection-population-strategies/manufacturers-to-product-cat.strategy.ts"/>
///<reference path="../collection-population-strategies/products-to-manufacturers.strategy.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import DP005ProductManufecturer = Meevo.Plugins.Reports.DP005ProductManufecturer;

    export class ReportDP005ProductsManufacturers extends DataTemplateBase implements IDataTemplate {

        protected productManufacturers: SmartMoverCollectionBase<DP005ProductManufecturer>;
        protected products: ReportDp005ProductsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.productManufacturers;
        }

        get leafCollection() {
            return this.products;
        }

        get totalSelectedCount() {
            return this.products.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.title = 'LABEL_PRODUCTS';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCTS';
            this.totalSelectedMessage = 'LABEL_PRODUCTS_SELECTED';

            angular.extend(options.criteria, {
                ProductState_TBL: [ObjectStateEnum.Active],
            });

            this.productManufacturers = new SmartMoverCollectionBase<DP005ProductManufecturer>(this.model[properties[0]], [], {
                idKey: 'manufacturer_TId',
                CategoryModel: VirtualRepeatCategory
            });

            this.products = new ReportDp005ProductsCollection(this.model[properties[1]], [], {
                criteria: options.criteria,
                idKey: 'variant_TId',
                reportModel: model
            }, options.$scope);

            this.validation.push(new RequiredValidation(this.products, 'LABEL_PRODUCTS_REQUIRED'));

            this.products.setParentCollection(this.productManufacturers, ProductsToManufacturersStrategy);
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: angular.IQService) {
            this.products.updateCriteria(newCriteria);

            return this.fetch(this.dataService);
        }

        fetch(dataService: Meevo.Components.BaseClasses.IDataService) {
            return this.products
                .fetch(dataService)
                .then((data) => {
                    if (data.length === 0) return;

                    this.products.handleResponse(data);

                    const productManufacturers = data.reduce((manufacturers, product) => {
                        const productManufacturer = product.dP005ProductManufecturers && product.dP005ProductManufecturers[0];
                        if (productManufacturer && !manufacturers.some((category) => productManufacturer.manufacturer_TId === category.manufacturer_TId)) {
                            manufacturers.push(productManufacturer)
                        }

                        return manufacturers;
                    }, [] as DP005ProductManufecturer[]);


                    this.productManufacturers.handleResponse(
                        _.sortBy(productManufacturers, (manufacture) => manufacture.displayName)
                    );
                    this.products.filterList();
                    this.products.onModelValueChanged();

                    this.emit(ON_FETCH_END);
                });
        }

        setWatchers(scope: angular.IScope) {
            scope.$watch(() => this.smartMoverHidden, (newValue: boolean, oldValue: boolean) => {
                if (newValue === oldValue) return;

                this.products.onModelValueChanged();
            });
        }
    }
}
